// extracted by mini-css-extract-plugin
export default {"root":"CheckDisputeForm_root__exqk3","field":"CheckDisputeForm_field__qUqIx","disputeText":"CheckDisputeForm_disputeText__O1cW4","error":"CheckDisputeForm_error__nr8R9"};